import React, { ReactElement } from 'react';
import styles from './ButtonWrapper.module.scss';

const ButtonWrapper = ({ children }: { children: ReactElement[] }): ReactElement => {
    return <div className={styles.buttonWrapper}>{children}</div>;
};

export default ButtonWrapper;
